import { QueovalBase, QueovalDate } from '../global/class.global';
import { EntiteReglement, qIbizaResponse, IbizaRequest } from '.';
export class MyDsoManagerModel extends QueovalBase {
  public ListEntites: Array<EntiteReglement>;
  public strIbizaResponse: qIbizaResponse;
  public IbizaRequest: IbizaRequest;
  public pieceColumnDefs: Array<Map<string, any>>;
  public pieceRowData: Array<Map<string, any>>;
  public clientColumnDefs: Array<Map<string, any>>;
  public clientRowData: Array<Map<string, any>>;
  public contactColumnDefs: Array<Map<string, any>>;
  public contactRowData: Array<Map<string, any>>;
  public CallAPI: boolean;
  constructor() {
    super();
  }

}
